/* Generated by npm run content:index. Keep full article copy in the lazy content bundle. */
export const EXPANDED_CONTENT_LANGUAGE_CODES = ['en', 'zh', 'hi', 'es', 'fr', 'ar', 'bn'] as const;
export const ENGLISH_CONTENT_ROUTE_ENTRIES = [
  {
    slug: '20-pattern-recognition-questions',
    title: '20 Pattern Recognition Questions with Answers',
  },
  {
    slug: 'adhd-accommodations-for-iq-testing',
    title: 'ADHD Accommodations in IQ Testing',
  },
  {
    slug: 'age-norms-in-iq-testing',
    title: 'Why Age Norms Matter in IQ Testing',
  },
  {
    slug: 'ai-and-iq-testing',
    title: 'AI and IQ Testing',
  },
  {
    slug: 'albert-einstein-iq',
    title: 'Albert Einstein IQ: what is actually known?',
  },
  {
    slug: 'analogical-reasoning-explained',
    title: 'Analogical Reasoning Explained',
  },
  {
    slug: 'analogies-practice',
    title: 'Verbal Analogies Practice',
  },
  {
    slug: 'are-iq-tests-culturally-biased',
    title: 'Are IQ Tests Culturally Biased?',
  },
  {
    slug: 'are-iq-tests-timed',
    title: 'Are IQ Tests Timed?',
  },
  {
    slug: 'attention-and-iq-testing',
    title: 'Attention and IQ Testing',
  },
  {
    slug: 'average-iq-by-age',
    title: 'Average IQ by Age',
  },
  {
    slug: 'average-iq-by-country',
    title: 'Average IQ by Country: Why Rankings Need Caution',
  },
  {
    slug: 'average-iq-in-argentina',
    title: 'Average IQ in Argentina: what can the data support?',
  },
  {
    slug: 'bell-curve-and-iq-scores',
    title: 'The Bell Curve and IQ Scores',
  },
  {
    slug: 'best-time-of-day-for-iq-test',
    title: 'What Is the Best Time of Day to Take an IQ Test?',
  },
  {
    slug: 'bilingualism-and-cognitive-testing',
    title: 'Bilingualism and Cognitive Testing',
  },
  {
    slug: 'bill-gates-iq',
    title: 'Bill Gates IQ: what is actually known?',
  },
  {
    slug: 'brain-age-test',
    title: 'Brain Age Test',
  },
  {
    slug: 'caffeine-before-an-iq-test',
    title: 'Should You Drink Caffeine Before an IQ Test?',
  },
  {
    slug: 'can-an-online-iq-score-be-exact',
    title: 'Can an Online IQ Score Be Exact?',
  },
  {
    slug: 'can-anxiety-lower-iq-scores',
    title: 'Can Anxiety Lower IQ Test Scores?',
  },
  {
    slug: 'can-education-increase-iq-scores',
    title: 'Can Education Increase IQ Scores?',
  },
  {
    slug: 'can-iq-change-over-time',
    title: 'Can IQ change over time?',
  },
  {
    slug: 'can-one-score-define-intelligence',
    title: 'Can One Score Define Intelligence?',
  },
  {
    slug: 'can-you-improve-your-iq',
    title: 'Can You Improve Your IQ?',
  },
  {
    slug: 'can-you-retake-an-iq-test',
    title: 'Can You Retake an IQ Test?',
  },
  {
    slug: 'can-you-take-an-iq-test-on-your-phone',
    title: 'Can You Take an IQ Test on Your Phone?',
  },
  {
    slug: 'cattell-horn-carroll-theory-explained',
    title: 'Cattell-Horn-Carroll Theory Explained',
  },
  {
    slug: 'ceiling-and-floor-effects-in-iq-testing',
    title: 'Ceiling and Floor Effects in IQ Testing',
  },
  {
    slug: 'cognitive-aging-studies',
    title: 'Cognitive Aging Studies Explained',
  },
  {
    slug: 'cognitive-flexibility-explained',
    title: 'Cognitive Flexibility Explained',
  },
  {
    slug: 'cognitive-reserve-explained',
    title: 'Cognitive Reserve Explained',
  },
  {
    slug: 'cognitive-style-quiz',
    title: 'Cognitive Style Quiz',
  },
  {
    slug: 'color-vision-test',
    title: 'Color Vision Screen',
  },
  {
    slug: 'comparing-iq-scores-over-time',
    title: 'How to Compare IQ Scores Over Time',
  },
  {
    slug: 'computer-adaptive-intelligence-testing',
    title: 'Computer-Adaptive Intelligence Testing',
  },
  {
    slug: 'concentration-exercises',
    title: 'Concentration Exercises',
  },
  {
    slug: 'construct-validity-intelligence-tests',
    title: 'Construct Validity in Intelligence Tests',
  },
  {
    slug: 'crystallized-intelligence',
    title: 'Crystallized Intelligence',
  },
  {
    slug: 'cube-rotation-puzzle-strategies',
    title: 'Cube Rotation Puzzle Strategies',
  },
  {
    slug: 'culture-fair-iq-tests',
    title: 'What Is a Culture-Fair IQ Test?',
  },
  {
    slug: 'daily-brain-challenge',
    title: 'Daily Brain Challenge',
  },
  {
    slug: 'deductive-reasoning-explained',
    title: 'Deductive Reasoning Explained',
  },
  {
    slug: 'deliberate-practice-and-cognitive-skills',
    title: 'Deliberate Practice and Cognitive Skills',
  },
  {
    slug: 'do-brain-games-raise-iq',
    title: 'Do Brain Games Raise IQ?',
  },
  {
    slug: 'do-testing-conditions-affect-iq-scores',
    title: 'Do Testing Conditions Affect IQ Scores?',
  },
  {
    slug: 'does-high-iq-always-mean-gifted',
    title: 'Does a High IQ Always Mean Gifted?',
  },
  {
    slug: 'does-iq-determine-success',
    title: 'Does IQ Determine Success in Life?',
  },
  {
    slug: 'does-iq-measure-creativity',
    title: 'Does an IQ Test Measure Creativity?',
  },
  {
    slug: 'does-iq-measure-potential',
    title: 'Does IQ Measure a Person’s Potential?',
  },
  {
    slug: 'does-language-affect-iq-test-scores',
    title: 'Does Language Affect IQ Test Scores?',
  },
  {
    slug: 'does-music-increase-intelligence',
    title: 'Does Music Increase Intelligence?',
  },
  {
    slug: 'does-sleep-affect-iq',
    title: 'Does Sleep Affect IQ Test Performance?',
  },
  {
    slug: 'dyslexia-and-iq-testing',
    title: 'Dyslexia and IQ Testing',
  },
  {
    slug: 'elon-musk-iq',
    title: 'Elon Musk IQ: what is actually known?',
  },
  {
    slug: 'executive-function',
    title: 'Executive Function Explained',
  },
  {
    slug: 'exercise-and-cognitive-performance',
    title: 'Exercise and Cognitive Performance',
  },
  {
    slug: 'fluid-intelligence',
    title: 'Fluid Intelligence',
  },
  {
    slug: 'flynn-effect',
    title: 'The Flynn Effect Explained',
  },
  {
    slug: 'free-online-iq-test-guide',
    title: 'Free online IQ test: what to expect',
  },
  {
    slug: 'free-vs-paid-iq-tests',
    title: 'Free vs Paid IQ Tests: What Is the Difference?',
  },
  {
    slug: 'full-scale-iq-vs-index-scores',
    title: 'Full Scale IQ vs Index Scores',
  },
  {
    slug: 'general-intelligence-g-factor-explained',
    title: 'The General Intelligence Factor (g) Explained',
  },
  {
    slug: 'healthy-cognitive-aging-explained',
    title: 'Healthy Cognitive Aging Explained',
  },
  {
    slug: 'highest-iq-ever-recorded',
    title: 'What is the highest IQ ever recorded?',
  },
  {
    slug: 'historical-iq-trends',
    title: 'Historical IQ Trends',
  },
  {
    slug: 'how-can-i-find-out-my-iq',
    title: 'How can I find out my IQ?',
  },
  {
    slug: 'how-iq-tests-are-standardized-and-normed',
    title: 'How IQ Tests Are Standardized and Normed',
  },
  {
    slug: 'how-is-iq-measured',
    title: 'How is IQ measured?',
  },
  {
    slug: 'how-long-does-an-iq-test-take',
    title: 'How Long Does an IQ Test Take?',
  },
  {
    slug: 'how-much-profile-scatter-is-normal',
    title: 'How Much Scatter in an IQ Profile Is Normal?',
  },
  {
    slug: 'how-soon-can-you-retake-an-iq-test',
    title: 'How Soon Can You Retake an IQ Test?',
  },
  {
    slug: 'how-to-explain-iq-confidence-intervals',
    title: 'How to Explain IQ Confidence Intervals',
  },
  {
    slug: 'how-to-prepare-for-an-iq-test',
    title: 'How to Prepare for an IQ Test',
  },
  {
    slug: 'how-to-read-an-iq-test-report',
    title: 'How to Read an IQ Test Report',
  },
  {
    slug: 'how-to-solve-pattern-rules',
    title: 'How to Solve Pattern Rules Step by Step',
  },
  {
    slug: 'how-to-take-an-iq-test',
    title: 'How to Take an IQ Test',
  },
  {
    slug: 'how-to-talk-about-iq-results',
    title: 'How to Talk About IQ Results Respectfully',
  },
  {
    slug: 'hydration-and-cognitive-testing',
    title: 'Hydration and Cognitive Testing',
  },
  {
    slug: 'inductive-reasoning-explained',
    title: 'Inductive Reasoning Explained',
  },
  {
    slug: 'intelligence-research-how-to-read-a-new-study',
    title: 'New Intelligence Study? How to Read the Evidence',
  },
  {
    slug: 'interruptions-during-online-iq-tests',
    title: 'What to Do if an IQ Test Is Interrupted',
  },
  {
    slug: 'iq-100-meaning',
    title: 'IQ 100 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-110-meaning',
    title: 'IQ 110 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-130-meaning',
    title: 'IQ 130 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-145-meaning',
    title: 'IQ 145 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-160-meaning',
    title: 'IQ 160 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-80-meaning',
    title: 'IQ 80 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-90-meaning',
    title: 'IQ 90 meaning: percentile and interpretation',
  },
  {
    slug: 'iq-distribution',
    title: 'IQ Distribution Explained',
  },
  {
    slug: 'iq-full-form',
    title: 'IQ Full Form: What Does IQ Stand For?',
  },
  {
    slug: 'iq-games-and-brain-puzzles',
    title: 'IQ games and brain puzzles',
  },
  {
    slug: 'iq-percentile-calculator',
    title: 'IQ Percentile Calculator',
  },
  {
    slug: 'iq-percentile-vs-percent-correct',
    title: 'IQ Percentile vs Percent Correct',
  },
  {
    slug: 'iq-percentiles',
    title: 'IQ Percentiles Table and Explanation',
  },
  {
    slug: 'iq-score-classification-labels',
    title: 'IQ Score Classification Labels Explained',
  },
  {
    slug: 'iq-score-confidence-intervals',
    title: 'IQ Score Confidence Intervals Explained',
  },
  {
    slug: 'iq-score-ranges-explained',
    title: 'IQ score ranges explained',
  },
  {
    slug: 'iq-test-accommodations-and-accessibility',
    title: 'IQ Test Accommodations and Accessibility',
  },
  {
    slug: 'iq-test-instructions-explained',
    title: 'IQ Test Instructions Explained',
  },
  {
    slug: 'iq-test-reliability',
    title: 'IQ Test Reliability Explained',
  },
  {
    slug: 'iq-test-validity',
    title: 'IQ Test Validity Explained',
  },
  {
    slug: 'iq-test-vs-mensa-test',
    title: 'IQ Test vs Mensa Admission Test',
  },
  {
    slug: 'iq-test-vs-neuropsychological-assessment',
    title: 'IQ Test vs Neuropsychological Assessment',
  },
  {
    slug: 'iq-testing-for-adults',
    title: 'IQ Testing for Adults: Purposes and Process',
  },
  {
    slug: 'iq-testing-for-older-adults',
    title: 'IQ Testing for Older Adults',
  },
  {
    slug: 'iq-testing-for-teenagers',
    title: 'IQ Testing for Teenagers: What to Expect',
  },
  {
    slug: 'iq-testing-for-young-children',
    title: 'IQ Testing for Young Children: A Parent Guide',
  },
  {
    slug: 'iq-tests-and-gifted-identification',
    title: 'IQ Tests and Gifted Identification',
  },
  {
    slug: 'iq-tests-and-learning-difficulties',
    title: 'IQ Tests and Learning Difficulties',
  },
  {
    slug: 'iq-vs-achievement-tests',
    title: 'IQ Tests vs Achievement Tests',
  },
  {
    slug: 'iq-vs-aptitude-tests',
    title: 'IQ Tests vs Aptitude Tests',
  },
  {
    slug: 'iq-vs-creativity',
    title: 'IQ vs Creativity',
  },
  {
    slug: 'iq-vs-critical-thinking',
    title: 'IQ vs Critical Thinking',
  },
  {
    slug: 'iq-vs-emotional-intelligence',
    title: 'IQ vs Emotional Intelligence',
  },
  {
    slug: 'iq-vs-eq',
    title: 'IQ vs EQ: what is the difference?',
  },
  {
    slug: 'iq-vs-executive-function',
    title: 'IQ vs Executive Function',
  },
  {
    slug: 'iq-vs-gpa',
    title: 'IQ vs GPA',
  },
  {
    slug: 'iq-vs-intelligence',
    title: 'IQ vs intelligence: are they the same?',
  },
  {
    slug: 'iq-vs-knowledge',
    title: 'IQ vs Knowledge',
  },
  {
    slug: 'iq-vs-memory',
    title: 'IQ vs Memory',
  },
  {
    slug: 'iq-vs-personality',
    title: 'IQ vs Personality',
  },
  {
    slug: 'iq-vs-problem-solving',
    title: 'IQ vs Problem-Solving Ability',
  },
  {
    slug: 'iq-vs-sat',
    title: 'IQ vs SAT',
  },
  {
    slug: 'iq-vs-wisdom',
    title: 'IQ vs Wisdom',
  },
  {
    slug: 'is-an-online-iq-test-accurate',
    title: 'Is an Online IQ Test Accurate?',
  },
  {
    slug: 'is-iq-fixed-at-birth',
    title: 'Is IQ Fixed at Birth?',
  },
  {
    slug: 'is-iq-genetic',
    title: 'Is IQ genetic?',
  },
  {
    slug: 'isaac-newton-iq',
    title: 'Isaac Newton IQ: what is actually known?',
  },
  {
    slug: 'item-difficulty-in-iq-tests',
    title: 'Item Difficulty in IQ Tests',
  },
  {
    slug: 'item-discrimination-in-iq-tests',
    title: 'Item Discrimination in IQ Tests',
  },
  {
    slug: 'learning-style-quiz',
    title: 'Learning Preferences Quiz',
  },
  {
    slug: 'leonardo-da-vinci-iq',
    title: 'Leonardo da Vinci IQ: what is actually known?',
  },
  {
    slug: 'light-yagami-iq',
    title: 'Light Yagami IQ: can a fictional character have a score?',
  },
  {
    slug: 'logic-puzzles',
    title: 'Logic Puzzles: Methods That Transfer',
  },
  {
    slug: 'logical-sequences-practice',
    title: 'Logical Sequences Practice',
  },
  {
    slug: 'low-iq-scores-explained',
    title: 'Low IQ scores explained responsibly',
  },
  {
    slug: 'marie-curie-iq',
    title: 'Marie Curie IQ: what is actually known?',
  },
  {
    slug: 'matrix-reasoning-practice',
    title: 'Matrix Reasoning Practice',
  },
  {
    slug: 'matrix-reasoning-strategies',
    title: 'Matrix Reasoning Strategies for Complex Puzzles',
  },
  {
    slug: 'measurement-invariance-iq-tests',
    title: 'Measurement Invariance in IQ Testing',
  },
  {
    slug: 'memory-exercises',
    title: 'Memory Exercises: a Practical Plan',
  },
  {
    slug: 'memory-research-explained',
    title: 'Memory Research Explained',
  },
  {
    slug: 'memory-test',
    title: 'Short-Term Memory Test',
  },
  {
    slug: 'mensa-iq-requirements',
    title: 'Mensa IQ requirements explained',
  },
  {
    slug: 'mental-age-calculator',
    title: 'Mental Age Calculator: History and Limits',
  },
  {
    slug: 'mental-math',
    title: 'Mental Math Techniques',
  },
  {
    slug: 'metacognition-and-problem-solving',
    title: 'Metacognition and Better Problem Solving',
  },
  {
    slug: 'multilingual-learners-and-iq-tests',
    title: 'Multilingual Learners and IQ Tests',
  },
  {
    slug: 'neuroplasticity-and-intelligence',
    title: 'Neuroplasticity and Intelligence',
  },
  {
    slug: 'nikola-tesla-iq',
    title: 'Nikola Tesla IQ: what is actually known?',
  },
  {
    slug: 'nonverbal-reasoning-explained',
    title: 'Nonverbal Reasoning Explained',
  },
  {
    slug: 'norm-referenced-testing-explained',
    title: 'Norm-Referenced IQ Testing Explained',
  },
  {
    slug: 'number-sequence-strategies',
    title: 'Number Sequence Strategies That Improve Accuracy',
  },
  {
    slug: 'number-series-practice',
    title: 'Number Series Practice',
  },
  {
    slug: 'nutrition-and-cognitive-performance',
    title: 'Nutrition and Cognitive Performance',
  },
  {
    slug: 'odd-one-out-reasoning-guide',
    title: 'Odd-One-Out Reasoning Guide',
  },
  {
    slug: 'paper-folding-spatial-strategies',
    title: 'Paper Folding and Hole-Punch Puzzle Strategies',
  },
  {
    slug: 'patrick-jane-iq',
    title: 'Patrick Jane IQ: fact, fiction, and fan estimates',
  },
  {
    slug: 'percentile-rank-in-iq-testing',
    title: 'What Percentile Rank Means in IQ Testing',
  },
  {
    slug: 'practice-effects-on-iq-tests',
    title: 'Practice Effects on IQ Tests',
  },
  {
    slug: 'processing-speed-explained',
    title: 'Processing Speed Explained',
  },
  {
    slug: 'processing-speed-games',
    title: 'Processing Speed Games',
  },
  {
    slug: 'quantitative-reasoning-explained',
    title: 'Quantitative Reasoning Explained',
  },
  {
    slug: 'ravens-progressive-matrices',
    title: 'Raven’s Progressive Matrices Explained',
  },
  {
    slug: 'raw-scores-vs-scaled-iq-scores',
    title: 'Raw Scores vs Scaled IQ Scores',
  },
  {
    slug: 'reaction-time-test',
    title: 'Reaction Time Test',
  },
  {
    slug: 'regression-to-the-mean-iq-scores',
    title: 'Regression to the Mean in IQ Scores',
  },
  {
    slug: 'rowan-atkinson-iq',
    title: 'Rowan Atkinson IQ: what is actually verified?',
  },
  {
    slug: 'sampling-error-in-test-norms',
    title: 'Sampling Error in IQ Test Norms',
  },
  {
    slug: 'screen-size-and-online-iq-tests',
    title: 'Does Screen Size Affect an Online IQ Test?',
  },
  {
    slug: 'short-term-memory-vs-working-memory',
    title: 'Short-Term Memory vs Working Memory',
  },
  {
    slug: 'should-you-guess-on-an-iq-test',
    title: 'Should You Guess on an IQ Test?',
  },
  {
    slug: 'sleep-before-cognitive-testing',
    title: 'Sleep Before Cognitive Testing: What the Evidence Means',
  },
  {
    slug: 'spatial-rotation-questions',
    title: 'Spatial Rotation Questions and Strategies',
  },
  {
    slug: 'speed-accuracy-balance-in-tests',
    title: 'Balancing Speed and Accuracy in Cognitive Tests',
  },
  {
    slug: 'standard-deviation-explained',
    title: 'Standard Deviation in IQ Testing',
  },
  {
    slug: 'standard-error-of-measurement-iq',
    title: 'Standard Error of Measurement in IQ Testing',
  },
  {
    slug: 'stanford-binet-intelligence-scales',
    title: 'Stanford–Binet Intelligence Scales Explained',
  },
  {
    slug: 'stanines-and-cognitive-scores',
    title: 'Stanines and Cognitive Scores Explained',
  },
  {
    slug: 'stephen-hawking-iq',
    title: 'Stephen Hawking IQ: what is actually known?',
  },
  {
    slug: 'stress-and-cognitive-performance',
    title: 'Stress and Cognitive Performance',
  },
  {
    slug: 'sudoku-strategies',
    title: 'Sudoku Strategies',
  },
  {
    slug: 'supervised-vs-unsupervised-iq-tests',
    title: 'Supervised vs Unsupervised IQ Tests',
  },
  {
    slug: 'syllogism-practice-strategies',
    title: 'Syllogism Practice Strategies',
  },
  {
    slug: 'taking-an-iq-test-when-sick',
    title: 'Should You Take an IQ Test When You Are Sick?',
  },
  {
    slug: 'test-anxiety-and-iq-performance',
    title: 'How Test Anxiety Can Affect IQ Performance',
  },
  {
    slug: 'test-retest-reliability-iq',
    title: 'Test–Retest Reliability in IQ Assessment',
  },
  {
    slug: 'time-pressure-in-iq-tests',
    title: 'How Time Pressure Works in IQ Tests',
  },
  {
    slug: 'twice-exceptional-learners-and-iq',
    title: 'Twice-Exceptional Learners and IQ Profiles',
  },
  {
    slug: 'understanding-iq-score-discrepancies',
    title: 'Understanding Differences Between IQ Index Scores',
  },
  {
    slug: 'using-cognitive-tests-in-workplace-decisions',
    title: 'Using Cognitive Tests in Workplace Decisions',
  },
  {
    slug: 'using-iq-results-in-school-decisions',
    title: 'Using IQ Results in School Decisions',
  },
  {
    slug: 'verbal-analogy-strategies',
    title: 'Verbal Analogy Strategies',
  },
  {
    slug: 'verbal-reasoning-explained',
    title: 'Verbal Reasoning Explained',
  },
  {
    slug: 'visual-reasoning-practice',
    title: 'Visual Reasoning Practice',
  },
  {
    slug: 'visual-spatial-reasoning-explained',
    title: 'Visual-Spatial Reasoning Explained',
  },
  {
    slug: 'wais-intelligence-test',
    title: 'WAIS Intelligence Test Explained',
  },
  {
    slug: 'what-age-should-children-take-an-iq-test',
    title: 'What Age Should Children Take an IQ Test?',
  },
  {
    slug: 'what-does-an-iq-of-120-mean',
    title: 'What does an IQ of 120 mean?',
  },
  {
    slug: 'what-does-an-iq-of-140-mean',
    title: 'What does an IQ of 140 mean?',
  },
  {
    slug: 'what-is-an-iq-test',
    title: 'What Is an IQ Test?',
  },
  {
    slug: 'what-is-considered-a-high-iq',
    title: 'What is considered a high IQ?',
  },
  {
    slug: 'what-is-iq',
    title: 'What Is IQ? Intelligence Quotient and IQ Tests Explained',
  },
  {
    slug: 'what-is-the-average-iq',
    title: 'What is the average IQ?',
  },
  {
    slug: 'what-makes-a-good-iq-norm-sample',
    title: 'What Makes a Good IQ Norm Sample?',
  },
  {
    slug: 'what-questions-are-on-an-iq-test',
    title: 'What Questions Are on an IQ Test?',
  },
  {
    slug: 'when-to-seek-a-second-opinion-on-testing',
    title: 'When to Seek a Second Opinion on Cognitive Testing',
  },
  {
    slug: 'why-iq-alone-cannot-diagnose',
    title: 'Why an IQ Score Alone Cannot Diagnose a Condition',
  },
  {
    slug: 'why-iq-scores-vary-between-tests',
    title: 'Why IQ Scores Can Vary Between Tests',
  },
  {
    slug: 'working-memory-explained',
    title: 'Working Memory Explained',
  },
  {
    slug: 'working-memory-practice-strategies',
    title: 'Working Memory Practice Strategies',
  },
  {
    slug: 'z-scores-and-iq',
    title: 'Z-Scores and IQ: A Plain-English Guide',
  },
] as const;
export const LOCALIZED_CONTENT_LANGUAGES = [
  'zh',
  'hi',
  'es',
  'fr',
  'ar',
  'bn',
  'ru',
  'id',
  'ja',
  'ko',
] as const;
export type LocalizedContentLanguage = (typeof LOCALIZED_CONTENT_LANGUAGES)[number];

export interface LocalizedContentRouteEntry {
  language: LocalizedContentLanguage;
  slug: string;
  title: string;
}

export const LOCALIZED_CONTENT_ROUTE_ENTRIES: LocalizedContentRouteEntry[] = [
  {
    language: 'zh',
    slug: 'can-anxiety-lower-iq-scores',
    title: '焦虑可以降低智商测试分数?',
  },
  {
    language: 'zh',
    slug: 'can-iq-change-over-time',
    title: '智商能随着时间的推移而改变吗?',
  },
  {
    language: 'zh',
    slug: 'can-you-improve-your-iq',
    title: '你能提高你的智商吗?',
  },
  {
    language: 'zh',
    slug: 'does-sleep-affect-iq',
    title: '睡眠是否影响智商测试的表现?',
  },
  {
    language: 'zh',
    slug: 'free-online-iq-test-guide',
    title: '免费在线智商测试: 什么可以期待',
  },
  {
    language: 'zh',
    slug: 'highest-iq-ever-recorded',
    title: '什么是有记录以来最高的智商?',
  },
  {
    language: 'zh',
    slug: 'how-can-i-find-out-my-iq',
    title: '如何找出我的智商?',
  },
  {
    language: 'zh',
    slug: 'how-is-iq-measured',
    title: '智商是如何测量的?',
  },
  {
    language: 'zh',
    slug: 'iq-distribution',
    title: '智商分布解释',
  },
  {
    language: 'zh',
    slug: 'iq-percentiles',
    title: '智商百分比表和解释',
  },
  {
    language: 'zh',
    slug: 'iq-score-ranges-explained',
    title: '智商分数范围解释',
  },
  {
    language: 'zh',
    slug: 'iq-vs-eq',
    title: '智商与EQ:有什么区别?',
  },
  {
    language: 'zh',
    slug: 'iq-vs-intelligence',
    title: '智商与智力:他们是相同的吗?',
  },
  {
    language: 'zh',
    slug: 'is-an-online-iq-test-accurate',
    title: '在线智商测试准确吗?',
  },
  {
    language: 'zh',
    slug: 'is-iq-genetic',
    title: '智商是遗传的吗?',
  },
  {
    language: 'zh',
    slug: 'low-iq-scores-explained',
    title: '低智商分数的解释负责任',
  },
  {
    language: 'zh',
    slug: 'mensa-iq-requirements',
    title: 'Mensa IQ 要求解释',
  },
  {
    language: 'zh',
    slug: 'what-is-considered-a-high-iq',
    title: '什么是高智商?',
  },
  {
    language: 'zh',
    slug: 'what-is-iq',
    title: '什么是智商?',
  },
  {
    language: 'zh',
    slug: 'what-is-the-average-iq',
    title: '什么是平均智商?',
  },
  {
    language: 'hi',
    slug: 'can-anxiety-lower-iq-scores',
    title: 'क्या IQ परीक्षण के परिणामों में कमी आ सकती है?',
  },
  {
    language: 'hi',
    slug: 'can-iq-change-over-time',
    title: 'समय के साथ IQ बदल सकता है?',
  },
  {
    language: 'hi',
    slug: 'can-you-improve-your-iq',
    title: 'क्या आप अपने IQ को बेहतर कर सकते हैं?',
  },
  {
    language: 'hi',
    slug: 'does-sleep-affect-iq',
    title: 'क्या नींद IQ परीक्षण प्रदर्शन को प्रभावित करती है?',
  },
  {
    language: 'hi',
    slug: 'free-online-iq-test-guide',
    title: 'गूगल प्ले स्टोर: क्या है?',
  },
  {
    language: 'hi',
    slug: 'highest-iq-ever-recorded',
    title: 'रिकॉर्ड की गई सबसे ऊंची IQ क्या है?',
  },
  {
    language: 'hi',
    slug: 'how-can-i-find-out-my-iq',
    title: 'मैं अपना IQ कैसे पता कर सकता हूँ?',
  },
  {
    language: 'hi',
    slug: 'how-is-iq-measured',
    title: 'IQ कैसे मापा जाता है?',
  },
  {
    language: 'hi',
    slug: 'iq-distribution',
    title: 'IQ वितरण समझाया',
  },
  {
    language: 'hi',
    slug: 'iq-percentiles',
    title: 'IQ Percentiles तालिका और व्याख्या',
  },
  {
    language: 'hi',
    slug: 'iq-score-ranges-explained',
    title: 'आईसीसी टूर्नामेंट्स रेटिंग',
  },
  {
    language: 'hi',
    slug: 'iq-vs-eq',
    title: 'IQ vs EQ: अंतर क्या है?',
  },
  {
    language: 'hi',
    slug: 'iq-vs-intelligence',
    title: 'IQ vs Intelligence: क्या वे एक ही हैं?',
  },
  {
    language: 'hi',
    slug: 'is-an-online-iq-test-accurate',
    title: 'क्या एक ऑनलाइन आईक्यू परीक्षण सटीक है?',
  },
  {
    language: 'hi',
    slug: 'is-iq-genetic',
    title: 'IQ आनुवंशिक है?',
  },
  {
    language: 'hi',
    slug: 'low-iq-scores-explained',
    title: 'IQ स्कोर के लिए निम्नलिखित मानदंड हैं।',
  },
  {
    language: 'hi',
    slug: 'mensa-iq-requirements',
    title: 'IQ का अर्थ है बुद्धि।',
  },
  {
    language: 'hi',
    slug: 'what-is-considered-a-high-iq',
    title: 'IQ को उच्च माना जाता है।',
  },
  {
    language: 'hi',
    slug: 'what-is-iq',
    title: 'IQ क्या है?',
  },
  {
    language: 'hi',
    slug: 'what-is-the-average-iq',
    title: 'औसत IQ क्या है?',
  },
  {
    language: 'es',
    slug: 'average-iq-in-argentina',
    title: 'IQ promedio en Argentina: qué permiten afirmar los datos',
  },
  {
    language: 'es',
    slug: 'can-anxiety-lower-iq-scores',
    title: '¿Puede la ansiedad disminuir los puntajes de las pruebas de CI?',
  },
  {
    language: 'es',
    slug: 'can-iq-change-over-time',
    title: '¿Puede el coeficiente intelectual cambiar con el tiempo?',
  },
  {
    language: 'es',
    slug: 'can-you-improve-your-iq',
    title: '¿Puedes mejorar tu coeficiente intelectual?',
  },
  {
    language: 'es',
    slug: 'does-sleep-affect-iq',
    title: '¿El sueño afecta el rendimiento de la prueba de CI?',
  },
  {
    language: 'es',
    slug: 'free-online-iq-test-guide',
    title: 'Test de IQ gratis en línea: qué esperar',
  },
  {
    language: 'es',
    slug: 'highest-iq-ever-recorded',
    title: '¿Cuál es el coeficiente intelectual más alto jamás registrado?',
  },
  {
    language: 'es',
    slug: 'how-can-i-find-out-my-iq',
    title: '¿Cómo puedo saber mi coeficiente intelectual?',
  },
  {
    language: 'es',
    slug: 'how-is-iq-measured',
    title: '¿Cómo se mide el CI?',
  },
  {
    language: 'es',
    slug: 'iq-distribution',
    title: 'Distribución de IQ explicada',
  },
  {
    language: 'es',
    slug: 'iq-percentiles',
    title: 'Tabla de Percentiles de CI y Explicación',
  },
  {
    language: 'es',
    slug: 'iq-score-ranges-explained',
    title: 'Rangos de puntuación de CI explicados',
  },
  {
    language: 'es',
    slug: 'iq-vs-eq',
    title: '¿Cuál es la diferencia entre IQ y EQ?',
  },
  {
    language: 'es',
    slug: 'iq-vs-intelligence',
    title: 'CI vs inteligencia: ¿son lo mismo?',
  },
  {
    language: 'es',
    slug: 'is-an-online-iq-test-accurate',
    title: '¿Es una prueba de CI en línea precisa?',
  },
  {
    language: 'es',
    slug: 'is-iq-genetic',
    title: '¿Es el coeficiente intelectual genético?',
  },
  {
    language: 'es',
    slug: 'low-iq-scores-explained',
    title: 'Los bajos puntajes de CI explicados de manera responsable',
  },
  {
    language: 'es',
    slug: 'mensa-iq-requirements',
    title: 'Explicación de los requisitos de Mensa IQ',
  },
  {
    language: 'es',
    slug: 'what-is-considered-a-high-iq',
    title: '¿Qué se considera un CI alto?',
  },
  {
    language: 'es',
    slug: 'what-is-iq',
    title: '¿Qué es el coeficiente intelectual?',
  },
  {
    language: 'es',
    slug: 'what-is-the-average-iq',
    title: '¿Cuál es el IQ promedio?',
  },
  {
    language: 'fr',
    slug: 'can-anxiety-lower-iq-scores',
    title: 'L’anxiété peut-elle abaisser les scores des tests de QI?',
  },
  {
    language: 'fr',
    slug: 'can-iq-change-over-time',
    title: 'Le QI peut-il changer au fil du temps?',
  },
  {
    language: 'fr',
    slug: 'can-you-improve-your-iq',
    title: 'Pouvez-vous améliorer votre QI?',
  },
  {
    language: 'fr',
    slug: 'does-sleep-affect-iq',
    title: 'Le sommeil affecte-t-il les performances du test de QI?',
  },
  {
    language: 'fr',
    slug: 'free-online-iq-test-guide',
    title: "Test de QI en ligne gratuit: à quoi s'attendre",
  },
  {
    language: 'fr',
    slug: 'highest-iq-ever-recorded',
    title: 'Quel est le QI le plus élevé jamais enregistré?',
  },
  {
    language: 'fr',
    slug: 'how-can-i-find-out-my-iq',
    title: 'Comment puis-je connaître mon QI?',
  },
  {
    language: 'fr',
    slug: 'how-is-iq-measured',
    title: 'Comment le QI est-il mesuré?',
  },
  {
    language: 'fr',
    slug: 'iq-distribution',
    title: 'Explication de la distribution IQ',
  },
  {
    language: 'fr',
    slug: 'iq-percentiles',
    title: 'Tableau et explication des percentiles de QI',
  },
  {
    language: 'fr',
    slug: 'iq-score-ranges-explained',
    title: 'Gammes de score de QI expliquées',
  },
  {
    language: 'fr',
    slug: 'iq-vs-eq',
    title: 'QI vs EQ : quelle est la différence?',
  },
  {
    language: 'fr',
    slug: 'iq-vs-intelligence',
    title: 'QI vs intelligence: sont-ils la même chose?',
  },
  {
    language: 'fr',
    slug: 'is-an-online-iq-test-accurate',
    title: 'Un test de QI en ligne est-il précis?',
  },
  {
    language: 'fr',
    slug: 'is-iq-genetic',
    title: 'Le QI est-il génétique?',
  },
  {
    language: 'fr',
    slug: 'low-iq-scores-explained',
    title: 'Les faibles scores de QI expliqués de manière responsable',
  },
  {
    language: 'fr',
    slug: 'mensa-iq-requirements',
    title: 'Explication des exigences de Mensa IQ',
  },
  {
    language: 'fr',
    slug: 'what-is-considered-a-high-iq',
    title: "Qu'est-ce qui est considéré comme un QI élevé?",
  },
  {
    language: 'fr',
    slug: 'what-is-iq',
    title: "Qu'est-ce que le QI?",
  },
  {
    language: 'fr',
    slug: 'what-is-the-average-iq',
    title: 'Quel est le QI moyen?',
  },
  {
    language: 'ar',
    slug: 'can-anxiety-lower-iq-scores',
    title: 'هل يخفض القلق معدل الذكاء؟',
  },
  {
    language: 'ar',
    slug: 'can-iq-change-over-time',
    title: 'هل يتغير معدل الذكاء مع مرور الوقت؟',
  },
  {
    language: 'ar',
    slug: 'can-you-improve-your-iq',
    title: 'هل تستطيع تحسين معدل ذكائك؟',
  },
  {
    language: 'ar',
    slug: 'does-sleep-affect-iq',
    title: 'هل يؤثر النوم على أداء اختبار الذكاء؟',
  },
  {
    language: 'ar',
    slug: 'free-online-iq-test-guide',
    title: 'اختبار ذكاء مجاني عبر الإنترنت: ما الذي ينبغي معرفته؟',
  },
  {
    language: 'ar',
    slug: 'highest-iq-ever-recorded',
    title: 'ما هو أعلى معدل ذكاء مسجل على الإطلاق؟',
  },
  {
    language: 'ar',
    slug: 'how-can-i-find-out-my-iq',
    title: 'كيف يمكنني معرفة معدل ذكائي؟',
  },
  {
    language: 'ar',
    slug: 'how-is-iq-measured',
    title: 'كيف يقاس معدل الذكاء؟',
  },
  {
    language: 'ar',
    slug: 'iq-distribution',
    title: 'توزيع IQ المشروح',
  },
  {
    language: 'ar',
    slug: 'iq-percentiles',
    title: 'الجدول المئوي لمعدل الذكاء وشرح ذلك',
  },
  {
    language: 'ar',
    slug: 'iq-score-ranges-explained',
    title: 'شرح نطاقات علامات الذكاء',
  },
  {
    language: 'ar',
    slug: 'iq-vs-eq',
    title: 'IQ مقابل EQ: ما هو الفرق؟',
  },
  {
    language: 'ar',
    slug: 'iq-vs-intelligence',
    title: 'معدل الذكاء مقابل الذكاء: هل هما نفس الشيء؟',
  },
  {
    language: 'ar',
    slug: 'is-an-online-iq-test-accurate',
    title: 'هل اختبار الذكاء على الإنترنت دقيق؟',
  },
  {
    language: 'ar',
    slug: 'is-iq-genetic',
    title: 'هل معدل الذكاء وراثي؟',
  },
  {
    language: 'ar',
    slug: 'low-iq-scores-explained',
    title: 'تفسير الدرجات المنخفضة لمعدل الذكاء بشكل مسؤول',
  },
  {
    language: 'ar',
    slug: 'mensa-iq-requirements',
    title: 'شروح متطلبات معدل الذكاء',
  },
  {
    language: 'ar',
    slug: 'what-is-considered-a-high-iq',
    title: 'ما هو معدل الذكاء المرتفع؟',
  },
  {
    language: 'ar',
    slug: 'what-is-iq',
    title: 'ما هو معدل الذكاء؟',
  },
  {
    language: 'ar',
    slug: 'what-is-the-average-iq',
    title: 'ما هو متوسط معدل الذكاء؟',
  },
  {
    language: 'bn',
    slug: 'can-anxiety-lower-iq-scores',
    title: 'উদ্বেগ কি আইকিউ টেস্টের স্কোর কমাতে পারে?',
  },
  {
    language: 'bn',
    slug: 'can-iq-change-over-time',
    title: 'IQ কি সময়ের সাথে সাথে পরিবর্তন হতে পারে?',
  },
  {
    language: 'bn',
    slug: 'can-you-improve-your-iq',
    title: 'আপনি কি আপনার আইকিউ উন্নত করতে পারবেন?',
  },
  {
    language: 'bn',
    slug: 'does-sleep-affect-iq',
    title: 'IQ টেস্টের ফলাফল কি ঘুমের উপর নির্ভর করে?',
  },
  {
    language: 'bn',
    slug: 'free-online-iq-test-guide',
    title: 'বিনামূল্যে অনলাইন আইকিউ টেস্ট: কি আশা করা যায়',
  },
  {
    language: 'bn',
    slug: 'highest-iq-ever-recorded',
    title: 'সর্বোচ্চ আই. কিউ. রেকর্ড করা কোনটা?',
  },
  {
    language: 'bn',
    slug: 'how-can-i-find-out-my-iq',
    title: 'আমি কিভাবে আমার আই. কিউ. খুঁজে বের করব?',
  },
  {
    language: 'bn',
    slug: 'how-is-iq-measured',
    title: 'IQ কিভাবে পরিমাপ করা হয়?',
  },
  {
    language: 'bn',
    slug: 'iq-distribution',
    title: 'আইসিসি টুয়েন্টি২০ বিশ্বকাপ',
  },
  {
    language: 'bn',
    slug: 'iq-percentiles',
    title: 'IQ Percentiles টেবিল এবং ব্যাখ্যা',
  },
  {
    language: 'bn',
    slug: 'iq-score-ranges-explained',
    title: 'আইকিউ স্কোরের পরিসীমা ব্যাখ্যা করা হয়েছে',
  },
  {
    language: 'bn',
    slug: 'iq-vs-eq',
    title: 'আইকিউ বনাম ইকু: এর মধ্যে পার্থক্য কি?',
  },
  {
    language: 'bn',
    slug: 'iq-vs-intelligence',
    title: 'আইকিউ বনাম বুদ্ধিমত্তা: এরা কি একই?',
  },
  {
    language: 'bn',
    slug: 'is-an-online-iq-test-accurate',
    title: 'অনলাইন আইকিউ টেস্ট কি সঠিক?',
  },
  {
    language: 'bn',
    slug: 'is-iq-genetic',
    title: 'আইকিউ কি জেনেটিক?',
  },
  {
    language: 'bn',
    slug: 'low-iq-scores-explained',
    title: 'কম আইকিউ স্কোরের কারণগুলোকে দায়িত্বশীলভাবে ব্যাখ্যা করা হয়েছে',
  },
  {
    language: 'bn',
    slug: 'mensa-iq-requirements',
    title: 'মেন্সা আইকিউ শর্তাবলী ব্যাখ্যা করা হয়েছে',
  },
  {
    language: 'bn',
    slug: 'what-is-considered-a-high-iq',
    title: 'কোনটাকে বলা হয় উচ্চ IQ?',
  },
  {
    language: 'bn',
    slug: 'what-is-iq',
    title: 'আই. কিউ. কি?',
  },
  {
    language: 'bn',
    slug: 'what-is-the-average-iq',
    title: 'গড় আই. কিউ. কত?',
  },
  {
    language: 'ru',
    slug: 'free-online-iq-test-guide',
    title: 'Бесплатный онлайн-тест IQ: что нужно знать',
  },
  {
    language: 'id',
    slug: 'free-online-iq-test-guide',
    title: 'Tes IQ online gratis: hal yang perlu diketahui',
  },
  {
    language: 'ja',
    slug: 'free-online-iq-test-guide',
    title: '無料オンラインIQテスト：受検前に知っておきたいこと',
  },
  {
    language: 'ja',
    slug: 'what-is-iq',
    title: 'IQとは？意味と測定できること',
  },
  {
    language: 'ja',
    slug: 'what-is-the-average-iq',
    title: 'IQの平均は？100の意味と分布',
  },
  {
    language: 'ko',
    slug: 'free-online-iq-test-guide',
    title: '무료 온라인 IQ 테스트: 시작 전에 알아둘 점',
  },
];
